if (!customElements.get('fpl-purchase')) {
 customElements.define('fpl-purchase', class extends HTMLElement {
  connectedCallback() {
   this.onChange = event => {
    if (event.target.tagName !== 'SELECT' || event.target.name !== 'id') return;
    const option = event.target.selectedOptions[0];
    const scope = this.closest('.fpl-hero-block');
    const price = scope.querySelector('[data-fpl-price]');
    let compare = scope.querySelector('[data-fpl-compare]');
    price.textContent = option.dataset.price;
    if (option.dataset.compare) {
     if (!compare) { compare = document.createElement('s'); compare.dataset.fplCompare = ''; price.before(compare); }
     compare.textContent = option.dataset.compare;
    } else if (compare) compare.remove();
   };
   this.addEventListener('change', this.onChange);
  }
  disconnectedCallback() { this.removeEventListener('change', this.onChange); }
 });
}
